import { EFileType } from '~/shared/types/file';
export var EFilterType;
(function (EFilterType) {
    EFilterType["all"] = "all";
    EFilterType["image"] = "image";
    EFilterType["video"] = "video";
    EFilterType["media"] = "all_media";
    EFilterType["documents"] = "doc";
    EFilterType["archives"] = "arch";
    EFilterType["photo"] = "photo";
})(EFilterType || (EFilterType = {}));
export const filterFileTypes = {
    [EFilterType.image]: [EFileType.image],
    [EFilterType.archives]: [EFileType.archive],
    [EFilterType.documents]: [EFileType.doc],
    [EFilterType.photo]: [EFileType.image],
    [EFilterType.video]: [EFileType.video],
    [EFilterType.media]: [EFileType.video, EFileType.image],
};
export var EFileInfoFilterType;
(function (EFileInfoFilterType) {
    EFileInfoFilterType["details"] = "details";
    EFileInfoFilterType["tags"] = "tags";
    EFileInfoFilterType["relatedFiles"] = "relatedFiles";
    EFileInfoFilterType["history"] = "history";
})(EFileInfoFilterType || (EFileInfoFilterType = {}));
export var EContactsFilter;
(function (EContactsFilter) {
    EContactsFilter["contributor"] = "contributor";
    EContactsFilter["member"] = "member";
    EContactsFilter["all"] = "all";
})(EContactsFilter || (EContactsFilter = {}));
